import React, {useState} from 'react'
import { Routes, Route } from 'react-router-dom'
import 'animate.css/animate.compat.css';
import { useLocation } from 'react-router-dom';
import './css/components/Sidebar.css';

// page imports
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminLogin from './components/AdminLogin';

// general imports
import Header from './general/Header';
import Footer from './general/Footer';
import PageNotFound from './general/PageNotFound';
import ScrollTop from './general/ScrollTop';
import ResponseMsg from './general/ResponseMsg';

// admin imports
import AdminDashboard from './admin/AdminDashboard';
import Sidebar from './admin/Sidebar';
import ManageProfile from './admin/ManageProfile';
import Inventory from './admin/Inventory';
import AddProduct from './admin/AddProduct';
import EditProduct from './admin/EditProduct';
import ViewParty from './admin/ViewParty';
import AddParty from './admin/AddParty';
import EditParty from './admin/EditParty';
import AddedCoupon from './admin/AddedCoupon';
import AddCoupon from './admin/AddCoupon';
import AddPurchase from './admin/AddPurchase';
import PurchaseHistory from './admin/PurchaseHistory';
import ViewUsers from './admin/ViewUsers';
import ManageStaff from './admin/ManageStaff';
import AddStaff from './admin/AddStaff';
import EditStaff from './admin/EditStaff';
import StaffLogin from './components/StaffLogin';
import StaffDashboard from './staff/StaffDashboard';
import Enquiry from './admin/Enquiry';
import ManageOrder from './admin/ManageOrder';
import ExchangeModel from './admin/ExchangeModel';
import AddSale from './admin/AddSale';
import SaleHistory from './admin/SaleHistory';
import Reports from './admin/Reports';

const App = () => {
 const location = useLocation();
  const collapsed = false;
    const isAdmin = localStorage.getItem(('isAdmin'));
    const isStaff = localStorage.getItem(('isStaff'));
const isAdminLogin = location.pathname === '/admin-login' || location.pathname === '/staff-login';
const [response, setResponse] = useState({ message: '', status: '' });
  const userData = JSON.parse(localStorage.getItem('userData'));


  return (
    <>
      <ScrollTop />

              {!isAdmin && !isStaff && (
<>
          {!isAdminLogin && <Header />}
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/about' element={<About />} />
        <Route exact path='/contact' element={<Contact setResponse={setResponse} />} />
        <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route exact path='/admin-login' element={<AdminLogin setResponse={setResponse} />} />
            <Route exact path='/staff-login' element={<StaffLogin setResponse={setResponse} />} />
        <Route exact path='*' element={<PageNotFound />} />
      </Routes>
          {!isAdminLogin && <Footer />}
</>
              )}


{isAdmin && (
  <>
            <Sidebar isAdmin={isAdmin} />
                      <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
            <Routes>
              <Route exact path='/' element={<AdminDashboard userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/manage-profile' element={<ManageProfile userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/inventory' element={<Inventory userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/add-product' element={<AddProduct setResponse={setResponse} />} />
              <Route exact path='/edit-product' element={<EditProduct setResponse={setResponse} />} />
              <Route exact path='/added-coupons' element={<AddedCoupon setResponse={setResponse} />} />
              <Route exact path='/add-coupon' element={<AddCoupon setResponse={setResponse} />} />
              <Route exact path='/view-users' element={<ViewUsers userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/manage-orders' element={<ManageOrder userData={userData[0]} setResponse={setResponse} />} />
<Route exact path='/exchange-detail' element={<ExchangeModel setResponse={setResponse} />} />
              <Route exact path='/add-party' element={<AddParty setResponse={setResponse} isModal={false} />} />
              <Route exact path='/view-party' element={<ViewParty setResponse={setResponse} />} />
              <Route exact path='/edit-party' element={<EditParty setResponse={setResponse} />} />
              <Route exact path='/add-purchase' element={<AddPurchase setResponse={setResponse} />} />
              <Route exact path='/purchase-history' element={<PurchaseHistory setResponse={setResponse} />} />
              <Route exact path='/add-sale' element={<AddSale userData={userData[0]} setResponse={setResponse} />} />


              <Route exact path='/sale-history' element={<SaleHistory userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/reports' element={<Reports userData={userData[0]} setResponse={setResponse} />} />

              <Route exact path='/manage-staff' element={<ManageStaff setResponse={setResponse} />} />
              <Route exact path='/add-staff' element={<AddStaff setResponse={setResponse} />} />
              <Route exact path='/edit-staff' element={<EditStaff setResponse={setResponse} />} />
              <Route exact path='/enquiry' element={<Enquiry />} />

</Routes>
</div>
  </>
)}

{isStaff && (
  <>
            <Sidebar isStaff={isStaff} userData={userData[0]} />
                      <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
<Routes>
              <Route exact path='/' element={<StaffDashboard userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/inventory' element={<Inventory userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/add-product' element={<AddProduct setResponse={setResponse} />} />
              <Route exact path='/edit-product' element={<EditProduct setResponse={setResponse} />} />
              <Route exact path='/added-coupons' element={<AddedCoupon setResponse={setResponse} />} />
              <Route exact path='/add-coupon' element={<AddCoupon setResponse={setResponse} />} />
              <Route exact path='/view-users' element={<ViewUsers userData={userData[0]} setResponse={setResponse} />} />
              <Route exact path='/add-party' element={<AddParty setResponse={setResponse} />} />
              <Route exact path='/view-party' element={<ViewParty setResponse={setResponse} />} />
              <Route exact path='/edit-party' element={<EditParty setResponse={setResponse} />} />
              <Route exact path='/add-purchase' element={<AddPurchase setResponse={setResponse} />} />
              <Route exact path='/purchase-history' element={<PurchaseHistory setResponse={setResponse} />} />
              <Route exact path='/manage-staff' element={<ManageStaff setResponse={setResponse} />} />
              <Route exact path='/add-staff' element={<AddStaff setResponse={setResponse} />} />
              <Route exact path='/edit-staff' element={<EditStaff setResponse={setResponse} />} />
</Routes>
</div>
</>
)}

{response.message && <ResponseMsg message={response.message} status={response.status} />}
    </>
  )
}

export default App
